import store from '@/store';
import {requireModule} from '@/routes/guards';

const DocumentsChildProfileFolder = () => import(/* webpackChunkName: "documents-module" */ '@/views/document/folder/DocumentChildProfileFolder.vue');
const DocumentIndex = () => import(/* webpackChunkName: "documents-module" */ '@views/document/views/DocumentIndex.vue');
const DocumentEdit = () => import(/* webpackChunkName: "documents-module" */ '@views/document/views/DocumentEdit.vue');
const DocumentFolder = () => import(/* webpackChunkName: "documents-module" */ '@views/document/folder/DocumentFolder.vue');
const DocumentDiaryIndex = () => import(/* webpackChunkName: "documents-module" */ '@views/document/views/DocumentDiaryIndex.vue');
const DocumentDiaryFolder = () => import(/* webpackChunkName: "documents-module" */ '@views/document/views/DocumentDiaryFolder.vue');

export default [
    {
        path: '/documents',
        name: 'document.index',
        components: { base: DocumentIndex },
        beforeEnter: requireModule('documents', (to, from, next) => {
            if (store.getters.canAccessDocumentsIndex) {
                next();
            } else {
                next({ path: '/access-restricted' });
            }
        })
    },
    {
        // Child-profile files are their own module, not part of Documents.
        path: '/documents/child-profile/:child_id?',
        name: 'document.builtin.child-profile',
        components: {base: DocumentsChildProfileFolder},
        beforeEnter: requireModule('child_profile_files', (to, from, next) => {
            const canAccessBuiltin =
                store.getters.canAccessChildFilesEmployee ||
                store.getters.canAccessChildFilesGuardian;
            if (store.getters.canAccessDocumentsIndex && canAccessBuiltin) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        })
    },
    {
        path: '/documents/diary',
        name: 'document.builtin.diary.index',
        components: {base: DocumentDiaryIndex},
        beforeEnter: requireModule('diaries', (to, from, next) => {
            if (store.getters.canAccessDocumentsIndex) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        })
    },
    {
        path: '/documents/diary/:course_id',
        name: 'document.builtin.diary',
        components: {base: DocumentDiaryFolder},
        beforeEnter: requireModule('diaries', (to, from, next) => {
            if (store.getters.canAccessDocumentsIndex) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        })
    },
    {
        path: '/documents/edit/:fileid',
        name: 'document.edit',
        components: { base: DocumentEdit },
        beforeEnter: requireModule('doc_editor', (to, from, next) => {
            if (store.getters.canAccessDocumentsEdit) {
                next();
            } else {
                next({ path: '/access-restricted' });
            }
        })
    },
    {
        path: '/documents/:folder',
        name: 'document.folder',
        components: { base: DocumentFolder },
        beforeEnter: requireModule('documents', (to, from, next) => {
            if (store.getters.canAccessDocumentsIndex) {
                next();
            } else {
                next({ path: '/access-restricted' });
            }
        })
    }
];
